import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';

import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import Table from '@decisiv/ui-components/lib/components/Table';

export const FilterWrapper = styled.div<{ $isActive?: boolean }>`
  cursor: pointer;
  height: ${rem(spacing.base * 2.4)};
  color: ${toColorString(color.base.snowWhite)};
  background-color: ${({ $isActive = false }) =>
    toColorString(
      $isActive
        ? color.base.midnight
        : color.visualInterest.licoriceMousse.medium,
    )};
`;

export const RightAlignedFlex = styled(Flex)`
  margin-left: auto;
  column-gap: 10px;
` as typeof Flex;

export const MinWidthSpan = styled.span<{ $minWidth: number }>`
  min-width: ${({ $minWidth }) => rem($minWidth)};
`;

export const NoWrapHeaderTable = styled(Table)`
  thead > tr > th {
    white-space: nowrap;
  }
` as unknown as typeof Table;

export const Separator = styled.div`
  height: ${rem(spacing.base * 2.4)};
  width: ${rem(spacing.base * 0.1)};

  background-color: ${toColorString(color.opacity.charcoal15)};
`;
